export var isTool = function isTool(value) {
  return ["name", "type"].every(function (key) {
    return key in value;
  });
};